<template>
  <div style="padding-top: 30px">
    <div style="padding-bottom: 30px">
      <p class="navadno-besedilo" v-if="izbranaStrankaInfo.tip_stranke === '0'">
        Visoke hitrosti interneta, nizek odzivni čas in zanesljiv dostop so le nekatere od prednosti, ki jih prinaša T-2 internet.
        Izberite internetno hitrost glede na zahteve, ki jih imate pri uporabi interneta.
      </p>
      <p class="navadno-besedilo" v-else>
        Visoke hitrosti interneta, nizek odzivni čas in zanesljiv dostop so le nekatere od prednosti, ki jih prinaša T-2 internet.
        <br/>Pri izbiri internetne hitrosti upoštevajte zahteve vašega posla in izberite tisto, ki najbolje ustreza vašim potrebam.
      </p>
    </div>
    <div class="postavitev-samostojne-hitrosti" v-loading="loadingNarociloNovegaPaketa || nalaganjePaketov">
      <div class="postavitev-paketov-samostojne-hitrosti" v-for="posamezenPaketSamostojneHitrosti in seznamHitrosti">
        <div>
          <div class="postavitev-naziva">
            <b>
              {{ posamezenPaketSamostojneHitrosti.naziv }}
            </b>
          </div>
          <div class="podcrtan-naziv-samostojne-hitrosti"/>
          <br/>
          <div class="izpis-cene-samostojne-hitrosti">
            {{ posamezenPaketSamostojneHitrosti.cena }} € / mesec
          </div>
          <div style="clear: both">
            <div>
              <div>
                <div class="postavitev-gumb-narocanje">
                  <OrderButton
                    v-if="posamezenPaketSamostojneHitrosti.naroceno === 1"
                    :disabled="true"
                    :services="[{serviceId: posamezenPaketSamostojneHitrosti.idStoritevVrstaIzbira, quantity: 0, terminationPointId: Number.parseInt(izbranPrikljucek)}]"
                    class="postavitev-gumb-narocanje"
                    :service-name="'samostojno hitrost ' + posamezenPaketSamostojneHitrosti.naziv"
                    @orderConfirmed="OsveziPodatke(); $emit('osveziPakete')"
                  >
                    NAROČENO
                  </OrderButton>
                  <div v-else-if="posamezenPaketSamostojneHitrosti.vklopljeno === 1"
                       class="postavitev-gumb-naroceno">
                    <a class="okvir-naroceno tekst-kontaktnih-podatkov">
                      <img src="/static/img/kljukica2.svg" width="12px"
                           style="vertical-align: middle; margin-right: 8px;"/>
                      <b>
                        VKLOPLJENO
                      </b>
                    </a>
                  </div>
                  <OrderButton
                    v-else-if="vklopljenaStoritevV30Dneh"
                    :disabled="true"
                    :services="[{serviceId: posamezenPaketSamostojneHitrosti.idStoritevVrstaIzbira, quantity: 0, terminationPointId: Number.parseInt(izbranPrikljucek)}]"
                    class="postavitev-gumb-narocanje"
                    :service-name="'samostojno hitrost ' + posamezenPaketSamostojneHitrosti.naziv"
                    @orderConfirmed="OsveziPodatke(); $emit('osveziPakete')"
                  >
                    {{`NAROČILO NA VOLJO ČEZ ${narociloCezStDni} DNI`}}
                  </OrderButton>
                  <OrderButton
                    v-else
                    :disabled="orderExists"
                    :services="[{serviceId: posamezenPaketSamostojneHitrosti.idStoritevVrstaIzbira, quantity: 1, terminationPointId: Number.parseInt(izbranPrikljucek)}]"
                    class="postavitev-gumb-narocanje"
                    :service-name="'samostojno hitrost ' + posamezenPaketSamostojneHitrosti.naziv"
                    @orderConfirmed="OsveziPodatke(); $emit('osveziPakete')">
                    NAROČI
                  </OrderButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <InfoKomponentaSamostojneHitrosti :dni-do-mozne-spremembe="narociloCezStDni" v-if="vklopljenaStoritevV30Dneh"/>
    </div>
  </div>
</template>
<script>
import {StoritevEnum} from '../../../../../assets/js/Enum/StoritevEnum.js'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {Select, Option, Form, Button, MessageBox} from 'element-ui'
import InfoKomponentaSamostojneHitrosti from './InfoKomponentaSamostojneHitrosti'
import OrderButton from '../../../../UIComponents/OrderButton.vue'
import Order from '../../../../../assets/js/Order/Order'
import moment from 'moment'

export default {
  name: 'SamostojneHitrosti',
  mixins: [SirinaOkna, StoritevEnum],
  data () {
    return {
      seznamSamostojneHitrosti: [],
      loadingNarociloNovegaPaketa: false,
      orderExists: false,
      narociloCezStDni: 0,
      vklopljenaStoritevV30Dneh: false
    }
  },
  props: {
    izbranPrikljucek: null,
    seznamHitrosti: null,
    nalaganjePaketov: null,
    izbranaStrankaInfo: null
  },
  components: {
    OrderButton,
    InfoKomponentaSamostojneHitrosti,
    [Button.name]: Button,
    [Form.name]: Form,
    [Option.name]: Option,
    [Select.name]: Select,
    Order
  },
  mounted () {
    this.OsveziPodatke()
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
    })
  },
  methods: {
    OsveziPodatke () {
      this.reloadOrderExists()
    },
    async reloadOrderExists () {
      if (this.izbranPrikljucek !== null) {
        try {
          this.orderExists = false
          this.narociloCezStDni = 0
          this.vklopljenaStoritevV30Dneh = false

          if (Array.isArray(this.seznamHitrosti)) {
            for (let i = 0; i < this.seznamHitrosti.length; i++) {
              if (this.seznamHitrosti[i].naroceno === 1) {
                this.orderExists = true
              }
              if (this.seznamHitrosti[i].vklopljeno === 1) {
                let today = new Date()
                let serviceActivatedDate = moment(this.seznamHitrosti[i].datumVklopa, 'DD.MM.YYYY HH:mm').toDate()
                let dateToCompare = new Date(serviceActivatedDate)
                dateToCompare.setDate(serviceActivatedDate.getDate() + 30)
                if (today < dateToCompare) {
                  const timeDifference = dateToCompare - today
                  this.vklopljenaStoritevV30Dneh = true
                  this.narociloCezStDni = Math.ceil(timeDifference / (1000 * 60 * 60 * 24))
                }
              }
            }
          }
        } catch (e) {
          this.ShowWarningMessage({message: 'Napaka pri pridobivanju obstoječih naročil'})
        }
      }
    },
    GetNarociSamostojnoHitrost (idStoritveHitrosti, naziv) {
      if (this.izbranPrikljucek !== '') {
        MessageBox.confirm('Ste prepričani, da želite naročiti izbrano internetno hitrost ? <br>' + naziv, {
          html: true,
          confirmButtonText: 'DA, ŽELIM NAROČITI',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog',
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.loadingNarociloNovegaPaketa = true
          let param = ['idPrikljucek=' + this.izbranPrikljucek]
          param.push('idTrzniPaket=' + StoritevEnum.BREZ_TRZNEGA_PAKEGA)
          param.push('idStoritveHitrosti=' + idStoritveHitrosti)
          this.clientAgent.postWsRequest(this,
            'prikljucek/storitve/narociTrzniPaket?',
            param,
            naziv,
            'SetSeznamSamostojnihHitrosti',
            'ErrSeznamSamostojnihHitrosti')
        }).catch(() => {
          MessageBox.alert('<strong>Niste izbrali prave internetne hitrosti?<br/>' +
            'Nič hudega, preverite še ostalo ponudbo.</strong>', {
            dangerouslyUseHTMLString: true,
            customClass: 'opozorilo-dialog',
            confirmButtonClass: 'gumb-potrdi'
          }).catch((err) => {
            err = null
          })
        })
      }
    },
    GetUspesnoNarocilo () {
      MessageBox.confirm(
        'Naročilo smo predali v obdelavo.\n' +
        'Ob zaključenem naročilu boste obveščeni na vašo mobilno številko. ', {
          center: true,
          showCancelButton: false,
          confirmButtonText: 'Zapri',
          iconClass: 'ikona-uspesno',
          customClass: 'uspesno-oddano'
        })
    },
    SetSeznamSamostojnihHitrosti (podatki, naziv) {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno naročena samostojna hitrost' + '(' + naziv + ').'
      this.ShowSuccessMessage(paramObvestilo)
      this.$emit('osveziPakete')
      this.loadingNarociloNovegaPaketa = false
    },
    ErrSeznamSamostojnihHitrosti (podatki) {
      this.ShowWarningMessage(podatki)
      this.loadingNarociloNovegaPaketa = false
      this.GetUspesnoNarocilo()
    }
  },
  watch: {
    seznamHitrosti: {
      deep: true,
      handler () {
        this.reloadOrderExists()
      }
    }
  }
}

</script>
<style scoped src="../../../../../../static/css/Naroci/NarociInternet/SamostojneHitrosti.css">
</style>
<style src="../../../../../../static/css/Naroci/NarociInternet/PojavnoOkno.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociInternet/SamostojneHitrosti.vue